export interface IMerchandiseType {
  id: number;
  name: string | null;
}

export enum MerchandiseType {
  TShirt = 'T-Shirt',
  Poster = 'Poster',
  Bag = 'Bag',
  Drinkware = 'Drinkware',
  Sweatshirt = 'Sweatshirt',
  ArtPrint = 'Art Print',
  Patch = 'Patch',
  Slipmat = 'Slipmat',
  Hoodie = 'Hoodie',
  Book = 'Book',
  Pin = 'Pin',
  Figurine = 'Figurine',
  Headwear = 'Headwear',
  Stationary = 'Stationary',
  Keychain = 'Keychain',
  OtherHardGood = 'Other Hard Good',
  Jacket = 'Jacket',
  Display = 'Display',
  PhoneCase = 'Phone Case',
  OtherApparel = 'Other Apparel',
  OtherPrint = 'Other Print',
  OtherAccessory = 'Other Accessory',
}
